import React from 'react'
import Text from '../../../../elements/Typo/Text'

interface Props {
    label: string
}

const Devider: React.FC<Props> = ({ label }) => {
    return (
        <div className="flex items-center">
            <hr className="flex-grow border-[#dadada]" />
            <div className="h-[1.083rem] px-4 bg-[#CED4DA] flex items-center rounded-[0.2rem] ">
                <Text size="md" className="font-medium leading-[1.083rem]">
                    {label}
                </Text>
            </div>
            <hr className="flex-grow border-[#dadada]" />
        </div>
    )
}

export default Devider
